import script from "./load-more-indicator.vue?vue&type=script&setup=true&lang=ts"
export * from "./load-more-indicator.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__